module.exports = __webpack_public_path__ + "static/img/bg4.a2d753d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg4.jpg
// module id = 7CmG
// module chunks = 1